import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect, useState, useRef, useCallback } from 'react';
import PropTypes from 'prop-types'; // from npm package react-material-snackbar which would not build

var SnackBar = function SnackBar(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showSnackBar = _useState2[0],
      setShowSnackBar = _useState2[1];

  var _useState3 = useState(60),
      _useState4 = _slicedToArray(_useState3, 2),
      localHeight = _useState4[0],
      setLocalHeight = _useState4[1];

  var show = props.show,
      delay = props.delay,
      onHideSnackbar = props.onHideSnackbar;
  var el = useRef(null);
  var hideSnackbar = useCallback(function () {
    setShowSnackBar(false);
    onHideSnackbar();
  }, [onHideSnackbar]);

  var setHeight = function setHeight() {
    if (el && el.clientHeight && localHeight !== el.clientHeight) {
      setLocalHeight(el.clientHeight);
    }
  };

  useEffect(function () {
    setShowSnackBar(show);
    var timer = delay && show ? setTimeout(hideSnackbar, delay) : null;
    return function () {
      return clearTimeout(timer);
    };
  }, [delay, hideSnackbar, show]);
  var bsStyle = props.bsStyle;
  var icon;

  switch (bsStyle) {
    case 'info':
      icon = 'fa-info-circle';
      break;

    case 'success':
      icon = 'fa-check';
      break;

    case 'warning':
    case 'danger':
      icon = 'fa-exclamation-triangle';
      break;

    default:
      icon = 'fa-info-circle';
  }

  var snackbarStyle = {
    position: 'fixed',
    left: 0,
    right: 0,
    top: "-".concat(localHeight + 30, "px"),
    transitionTimingFunction: 'ease-in-out',
    transition: '300ms',
    transform: showSnackBar ? "translateY(".concat(localHeight + 50, "px)") : 'translateY(0px)',
    zIndex: '2000',
    visibility: showSnackBar ? 'visible' : 'hidden'
  };
  setHeight();
  return React.createElement("div", {
    className: "snackbar snackbar-".concat(bsStyle),
    style: snackbarStyle
  }, React.createElement("div", {
    className: "snackbar-icon"
  }, React.createElement("i", {
    className: "fa ".concat(icon)
  })), React.createElement("div", {
    className: "snackbar-text"
  }, props.children), React.createElement("button", {
    type: "button",
    className: "close",
    "aria-hidden": "true",
    onClick: hideSnackbar
  }, "\xD7"));
};

SnackBar.defaultProps = {
  bsStyle: 'success',
  show: false
};
SnackBar.propTypes = {
  bsStyle: PropTypes.oneOf(['success', 'info', 'warning', 'danger']),
  show: PropTypes.bool,
  delay: PropTypes.number,
  children: PropTypes.node,
  onHideSnackbar: PropTypes.func.isRequired
};
export default SnackBar;